import { Link } from "react-router-dom";
import { Trash2, ArrowRight, ShoppingBag } from "lucide-react";
import { formatPrice } from "../lib/api";
import { useCart } from "../context/CartContext";

export default function Cart() {
  const { items, removeItem, total } = useCart();

  if (items.length === 0)
    return (
      <div className="pt-40 pb-24 max-w-3xl mx-auto px-6 text-center min-h-screen" data-testid="cart-empty">
        <ShoppingBag className="h-12 w-12 text-zinc-700 mx-auto mb-6" strokeWidth={1} />
        <h1 className="font-display text-4xl text-white mb-4">Votre panier est vide</h1>
        <p className="text-zinc-400 mb-8">Parcourez la galerie pour découvrir nos œuvres uniques.</p>
        <Link to="/galerie" className="inline-flex items-center gap-2 bg-[#2563EB] hover:bg-[#1D4ED8] text-white px-8 py-4 text-sm transition-colors">
          Voir la galerie <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    );

  return (
    <div className="pt-32 pb-24 max-w-5xl mx-auto px-6 lg:px-10 min-h-screen" data-testid="cart-page">
      <h1 className="font-display text-5xl text-white tracking-tight mb-12">Votre panier</h1>

      <div className="space-y-6">
        {items.map((item) => (
          <div key={item.id} className="flex gap-6 border-b border-white/10 pb-6" data-testid={`cart-item-${item.id}`}>
            <Link to={`/oeuvre/${item.id}`} className="shrink-0">
              <img src={item.image_url} alt={item.title} className="h-28 w-24 object-cover" />
            </Link>
            <div className="flex-1 flex flex-col sm:flex-row sm:items-center justify-between gap-4">
              <div>
                <h3 className="font-display text-2xl text-white">{item.title}</h3>
                <p className="text-zinc-500 text-sm">{item.artist_name}</p>
              </div>
              <div className="flex items-center gap-6">
                <span className="text-white text-lg">{formatPrice(item.price)}</span>
                <button
                  data-testid={`remove-item-${item.id}`}
                  onClick={() => removeItem(item.id)}
                  className="text-zinc-500 hover:text-[#E11D48] transition-colors"
                  aria-label="Retirer"
                >
                  <Trash2 className="h-5 w-5" />
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-12 flex flex-col items-end gap-6">
        <div className="flex items-center gap-12">
          <span className="text-zinc-400 uppercase tracking-widest text-sm">Total</span>
          <span className="text-3xl text-white font-light" data-testid="cart-total">{formatPrice(total)}</span>
        </div>
        <Link
          to="/paiement"
          data-testid="checkout-button"
          className="inline-flex items-center gap-3 bg-[#2563EB] hover:bg-[#1D4ED8] text-white px-12 py-4 text-sm tracking-wide transition-colors"
        >
          Passer au paiement <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </div>
  );
}
